<template>
  <div class="card mb-0 border-0 shadow-0 ">
    <div class="card-body text-center py-5 mb-5">
      <div class="mt-5 mb-3">
        <img
          src="@/assets/global_assets/images/access_not_available.png"
          class=""
          alt=""
          width="389.77pxpx"
        >
      </div>
      <h1 class="error-page-title">
        {{ $t('Access Not Available') + "!" }}
      </h1>
      <div class="error-page-text">
        <div class="d-flex justify-content-center">
          <span
            style="max-width:30%"
          >
            {{ $parent.featureNotAvailableLabel || $t("Current plan is not support this feature. Please subscribe upper plan to access the feature.") }}
          </span>
        </div>
      </div>
      <div class="mt-3">
        <button
          v-if="redirectBuyPlan"
          class="btn btn-lg btn-primary"
          @click="redirectToBuyPlan()"
        >
          <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t('Upgrade Now') + "!" }}
        </button>
        <button
          v-else
          class="btn btn-lg btn-primary"
          @click="redirectTo()"
        >
          <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t('Upgrade Now') + "!" }}
        </button>
      </div>
    </div>
  </div>
</template>
    
    <script>
    export default {
        components: {},
        props: {
            redirectBuyPlan: {
              type: [Boolean],
              default: false
            }, 
        },
        data() {
            return {
                redirect: 'https://gosell.tech/price',
                urlPath: '/app/premium-subscriptions',
            }
        },
        methods: {
            redirectTo() {
                window.location.href = this.redirect;
            },
            redirectToBuyPlan(){
              this.$nextTick( () => {
                this.$router.push({ path: this.urlPath});
              });
            },
        },
    };
    </script>
    


// WEBPACK FOOTER //
// src/components/tenancy/admin/error-page/templates/AccessNotAvailable.vue